<template lang="pug">
form-item-wrapper(v-bind="bind", :rules="rules", :class="formItemClass")
  city-input.width-full(v-model="fieldModel", @change="emitValidate", :level="showLevel", :readonly="!isEdit", :label.sync="fieldLabel")
</template>
<script>
import { mapVFAssignField, staticMixins } from "@/CommonDP/VForm/utils";
import CityInput from "./input";
export default {
  components: { CityInput },
  mixins: [staticMixins],
  data() {
    return {
      rules: [],
      cityMap: {},
      defaultValue: ""
    };
  },
  computed: {
    ...mapVFAssignField({ fieldLabel: "assignToName" }),
    vmDefaultValue() {
      return this.options.defaultCity;
    },
    showLevel() {
      return this.options.showLevel;
    }
  }
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
